<template>
    <div class="box">
        <div class="form-group mb-2">
            <div class="row">
                <label for="title" class="col-md-3 col-form-label text-md-end">
                    {{ $t("general.writeTitleEvent") }}
                </label>
                <div class="col-md-9">
                    <input type="text" id="title" class="form-control" v-model="localEvent.title">
                </div>
            </div>
        </div>

        <div class="form-group mb-2">
            <div class="row">
                <label for="description" class="col-md-3 col-form-label text-md-end">
                    {{ $t("general.writeDescriptionEvent") }}
                </label>
                <div class="col-md-9">
                    <textarea id="description" class="form-control" v-model="localEvent.description"></textarea>
                </div>
            </div>
        </div> 

        <div class="form-group mb-2">
            <div class="row">
                <label for="location" class="col-md-3 col-form-label text-md-end">
                    {{ $t("general.writeLocationEvent") }}
                </label>
                <div class="col-md-9">
                    <input type="text" id="location" class="form-control" v-model="localEvent.location">
                </div>
            </div>
        </div>

        <div class="form-group mb-2">
            <div class="row align-items-center">
                <label for="allDay" class="col-md-3 col-form-label text-md-end">
                    {{ $t("general.allDayEvent") }}
                </label>
                <div class="col-md-9">
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="localEvent.allDay">
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group mb-2">
            <div class="row">
                <label for="startDate" class="col-md-3 col-form-label text-md-end">
                    {{ $t("general.writeStartDateEvent") }}
                </label>
                <div class="col-md-9 d-flex">
                    <input type="date" id="startDate" class="form-control me-2" v-model="localEvent.startDate">
                    <input v-if="!localEvent.allDay" type="time" id="startTime" class="form-control" v-model="localEvent.startTime">
                </div>
            </div>
        </div>

        <div class="form-group mb-2">
            <div class="row">
                <label for="endDate" class="col-md-3 col-form-label text-md-end">
                    {{ $t("general.writeEndDateEvent") }}
                </label>
                <div class="col-md-9 d-flex">
                    <input type="date" id="endDate" class="form-control me-2" v-model="localEvent.endDate">
                    <input v-if="!localEvent.allDay" type="time" id="endTime" class="form-control" v-model="localEvent.endTime">
                </div>
            </div>
        </div>

        <div class="modal-footer border-0 d-flex gap-2 justify-content-center">
            <button type="button" class="btn btn_secondary" data-bs-dismiss="modal" style="width: 130px;">
                <span>{{ $t('utils.close') }}</span>
            </button>
            <button @click="submitForm" type="button" class="btn btn_main" data-bs-dismiss="modal" style="width: 130px;">
                <span>{{ $t('utils.submit') }}</span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            event: {
                type: Object,
                default: () => ({
                    title: "",
                    description: "",
                    location: "",
                    allDay: false,
                    startDate: "",
                    startTime: "",
                    endDate: "",
                    endTime: ""
                })
            }
        },
        data() {
            return {
                localEvent: { ...this.event }
            };
        },
        methods: {
            submitForm() {
                this.$emit("submit", this.localEvent);
            }
        },
        watch: {
            event: {
                handler(newVal) {
                    this.localEvent = { ...newVal };
                },
                deep: true,
                immediate: true
            },
            // Automaticke doplnovani endDate pokud je allDay true
            "localEvent.startDate"(newStartDate) {
                if (this.localEvent.allDay && newStartDate) {
                    this.localEvent.endDate = newStartDate;
                }
            },
            "localEvent.allDay"(newAllDay) {
                if (this.localEvent.startDate && newAllDay) {
                    this.localEvent.endDate = this.localEvent.startDate;
                }
            }
        }
    }
</script>
